import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var JQLValidationTooltipPluginKey = new PluginKey('jql-validation-tooltip-plugin');
export var TOOLTIP_CLASSNAME = 'jql-validation-tooltip';
export var TOOLTIP_ENTER_CLASSNAME = 'jql-validation-tooltip-enter';
export var TOOLTIP_EXIT_CLASSNAME = 'jql-validation-tooltip-exit';